export class Presenter {

  noValue = '-';

  getOrDefault(value, defaultValue) {
    if (value)
      return value;

    if (typeof defaultValue == 'undefined')
      return null;

    return defaultValue;
  }

  getMapped(value, callback) {
    if (value)
      return callback(value);

    return this.noValue;
  }
}

const defaultPresenter = new Presenter();

export {defaultPresenter};
